import React, {Fragment,useState,useEffect,useRef} from 'react';
import {Row, Col,
  Card,
  CardTitle,Button,Label,Input } from 'reactstrap';

import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import Clessidra from '../Clessidra.js';
import Parametri from '../../parametri';
import TendinaEditabile from '../TendinaEditabile.js';

import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';

const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI = 1;
const STATO_OPERAZIONE_CORRETTA= 2;
const STATO_ERRORE_CONNESSIONE= 3;
const STATO_RICERCA_DATI_DETTAGLIO= 5;
const STATO_SCARICA_PDF = 9;

function TabellaElencoPrenotazioni(props) {

    function formattaData(date) {
      let mese = String(date.getMonth()+1);
      if(mese.length === 1) mese = "0"+mese;

      let giorno = String(date.getDate());
      if(giorno.length === 1) giorno = "0"+giorno;

      return date.getFullYear()+'-'+mese+'-'+giorno;
    }

    var today = new Date();
    const dataOggi = formattaData(today);

    // oggi + 7 giorni
    var traUnaSettimana = new Date();
    traUnaSettimana.setDate(today.getDate() + 7);
    const dataOggiPiu7 = formattaData(traUnaSettimana);

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [variazioneCampi,setVariazioneCampi]=useState(0);

    const [statoTendinaIscritto,setStatoTendinaIscritto]=useState(false);
    const [statoTendinaPrestazione,setStatoTendinaPrestazione]=useState(false);
    const [risultatoServerDatiPersona,setRisultatoServerDatiPersona]=useState('');
    const [risultatoServerDatiPrestazioni,setRisultatoServerDatiPrestazioni]=useState('');
    const [risultatoPrenotazioni,setRisultatoPrenotazioni]=useState([]);

    const [insPrestazioneEdi,setInsPrestazioneEdi]=useState('');
    const [insIdPrestazioneEdi,setInsIdPrestazioneEdi]=useState('');

    const [insPersonaEdi,setInsPersonaEdi]=useState('');
    const [insIdPersonaEdi,setInsIdPersonaEdi]=useState('');

    const [defaultPrestazione,setDefaultPrestazione]=useState('');
    const [defaultPersona,setDefaultPersona]=useState('');

    const [error,setError]=useState('');

    const dataPartenza = useRef();
    const dataArrivo = useRef();
    const [dataPartenzaDefault,setDataPartenzaDefault]=useState(dataOggi);
    const [dataArrivoDefault,setDataArrivoDefault]=useState(dataOggiPiu7);  

    const [loading,setLoading]= useState(false);

    const [calcola,setCalcola]=useState(false);
    const [visualizza,setVisualizza]=useState(false);
    const [visualizzaInPdf,setVisualizzaInPdf]=useState(false);

    const [modalitaReport,setModalitaReport]=useState('elenco');

    const [risultatiCognome,setRisultatiCognome]=useState([]);
    const [risultatiNome,setRisultatiNome]=useState([]);
    const [risultatiTessera,setRisultatiTessera]=useState([]);
    const [risultatiDescrizione,setRisultatiDescrizione]=useState([]);
    const [risultatiDa,setRisultatiDa]=useState([]);
    const [risultatiA,setRisultatiA]=useState([]);
    const [risultatiStato,setRisultatiStato]=useState([]);

    const [ricercaLogo,setRicercaLogo]=useState('');
    const [fileLogo,setFileLogo]=useState('');
    const [typeLogo,setTypeLogo]=useState('');
    const [nomeSocieta,setNomeSocieta]=useState('');
    const [capSocieta,setCapSocieta]=useState('');
    const [cittaSocieta,setCittaSocieta]=useState('');
    const [indirizzoSocieta,setIndirizzoSocieta]=useState('');
    const [pIvaSocieta,setPIvaSocieta]=useState('');
    const [codiceFiscaleSocieta,setCodiceFiscaleSocieta]=useState('');

    var elem = document.getElementById("cont");
    const [larghezzaPdf,setLarghezzaPdf] = useState(0);

    useEffect(() => {
      if(elem) setLarghezzaPdf(elem.getBoundingClientRect().width);
    },[elem]);

    useEffect(() => {
      setStatoTendinaIscritto(false);
      ricercaDatiPersona();
      setDefaultPrestazione("Tutti");
      setDefaultPersona("Tutti");
      setDataPartenzaDefault(dataOggi);
      setDataArrivoDefault(dataOggiPiu7);
      scaricaLogo();
    },[]);

    useEffect(() => {
      setVisualizza(false);
      setCalcola(false);
    },[insPersonaEdi,insPrestazioneEdi,dataPartenzaDefault,dataArrivoDefault]);

    useEffect(() => {
      if(calcola === true){
        ricercaDatiPrenotazioni();
      }
    },[calcola]);

    useEffect(() => {
      if(visualizzaInPdf === true) {
        setStatoPagina(STATO_SCARICA_PDF);
      }
    },[visualizzaInPdf]);

    useEffect(() => {
      if(statoTendinaPrestazione === true && statoTendinaIscritto === true  && ricercaLogo === 1){
        setStatoPagina(STATO_OPERAZIONE_CORRETTA);
      }
    },[statoTendinaIscritto,statoTendinaPrestazione,ricercaLogo]);

    function ricercaDatiPrenotazioni(){
      setLoading(true);
      let dataP = '';
      let dataA = '';
      if(dataPartenza.current) dataP = dataPartenza.current.value;
      if(dataArrivo.current) dataA = dataArrivo.current.value;

      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            op:"reportElencoPrenotazioni",
            idPersona:insIdPersonaEdi,
            idCorso:insIdPrestazioneEdi,
            dataInizio:dataP,
            dataFine:dataA,
            emak: props.emak,
            sessionId:props.sessionId
          })
      };

      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
              setLoading(false);
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
              }
              if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
              if(valoreDiRitorno.risultatoOperazione===1){
                  let arrLocale1=[];//cognome
                  let arrLocale2=[];//nome
                  let arrLocale3=[];//tessera
                  let arrLocale4=[];//prestazione
                  let arrLocale5=[];//data inizio
                  let arrLocale6=[];//data fine
                  let arrLocale7=[];//stato

                  for (let i=0; i<valoreDiRitorno.risultatoRitorno.length ; i++) {
                    arrLocale1[i]=valoreDiRitorno.risultatoRitorno[i].COGNOME;
                    arrLocale2[i]=valoreDiRitorno.risultatoRitorno[i].NOME;
                    arrLocale3[i]=valoreDiRitorno.risultatoRitorno[i].NUMERO_TESSERA;
                    arrLocale4[i]=valoreDiRitorno.risultatoRitorno[i].DESCRIZIONE;
                    arrLocale5[i]=valoreDiRitorno.risultatoRitorno[i].DATA_INIZIO;
                    arrLocale6[i]=valoreDiRitorno.risultatoRitorno[i].DATA_FINE;
                    arrLocale7[i]=valoreDiRitorno.risultatoRitorno[i].STATO;
                  }

                  setRisultatiCognome(arrLocale1);
                  setRisultatiNome(arrLocale2);
                  setRisultatiTessera(arrLocale3);
                  setRisultatiDescrizione(arrLocale4);
                  setRisultatiDa(arrLocale5);
                  setRisultatiA(arrLocale6);
                  setRisultatiStato(arrLocale7);
                  setRisultatoPrenotazioni(valoreDiRitorno.risultatoRitorno);
                  setVisualizza(true);
                  setCalcola(false);
              }
          },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
    }

    function scaricaLogo() {
      setLoading(true);
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"ricercaLogo", emak: props.emak,sessionId: props.sessionId})
      };

      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
        (valoreDiRitorno) => {
          setLoading(false);
          if(valoreDiRitorno.risultatoOperazione===1){
              if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
                setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
                setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
                setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
                setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
                setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
                setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
                setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
                setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
              }
              setRicercaLogo(1);
          }
        },
        (error) => {console.log("Errore connessione");}
      );
    }

    function ricercaDatiPersona() {
      setLoading(true);
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"elencoPersone",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
      };

      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
              setLoading(false);
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
              }
              if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
              if(valoreDiRitorno.risultatoOperazione===1){
                  setRisultatoServerDatiPersona(valoreDiRitorno.risultatoRitorno);
                  setStatoTendinaIscritto(true);
                  ricercaDatiPrestazioni();
              }
          },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
    }

    function ricercaDatiPrestazioni() {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoCorsi",emak: props.emak,sessionId:props.sessionId})
        };

        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
              setLoading(false);
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
              }
              if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
              if(valoreDiRitorno.risultatoOperazione===1){
                  setRisultatoServerDatiPrestazioni(valoreDiRitorno.risultatoRitorno);
                  setStatoTendinaPrestazione(true);
                  setCalcola(false);
              }
            },
            (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function callbackSetVariazioneCampi(variazioneCampi){
      setVariazioneCampi(variazioneCampi);
    }

    function callbackSetValoreTendEditabilePersona(valore,pos,valoreNonVisibile){
      setInsPersonaEdi(valore);
      setInsIdPersonaEdi(valoreNonVisibile);
    }

    function callbackSetValoreTendEditabilePrestazione(valore,pos,valoreNonVisibile){
      setInsPrestazioneEdi(valore);
      setInsIdPrestazioneEdi(valoreNonVisibile);
    }

    function callbackTermineModifica() {
      setStatoPagina(STATO_RICERCA_DATI);
    }

    function decodificaStato(stato) {
      var r = "";
      switch (Number(stato)) {
        case -1: r = "attesa"; break;
        case 0: r = "attiva"; break;
        case 1: r = "conclusa"; break;
        case 2: r = "annullata"; break;
        default: r = "";
      }
      return r;
    }

    function formattaDataOraIntervallo(dataInizio, dataFine) {
      if(!dataInizio || !dataFine) return "";

      var partiInizio = dataInizio.split('T');
      var partiFine = dataFine.split('T');

      if(partiInizio.length < 2 || partiFine.length < 2) return "";

      var dataI = partiInizio[0];
      var oraI = partiInizio[1].substring(0,5);

      var dataF = partiFine[0];
      var oraF = partiFine[1].substring(0,5);

      if(dataI === dataF) {
        return dataI.split('-').reverse().join('/') + " " + oraI + " - " + oraF;
      }

      return dataI.split('-').reverse().join('/') + " " + oraI + " - " + dataF.split('-').reverse().join('/') + " " + oraF;
    }    

    function parseDataSoloGiorno(dataIso) {
      if(!dataIso) return null;

      var parteData = dataIso.split('T')[0];
      var pezzi = parteData.split('-');
      if(pezzi.length !== 3) return null;

      return new Date(
        parseInt(pezzi[0], 10),
        parseInt(pezzi[1], 10) - 1,
        parseInt(pezzi[2], 10)
      );
    }

    function getChiaveMeseDaData(dateObj) {
      if(!dateObj) return "";
      var mese = String(dateObj.getMonth() + 1);
      if(mese.length === 1) mese = "0" + mese;
      return mese + "/" + dateObj.getFullYear();
    }

    function getPrimoGiornoDelMeseDaChiave(chiaveMese) {
      var pezzi = chiaveMese.split('/');
      if(pezzi.length !== 2) return null;

      var mese = parseInt(pezzi[0], 10);
      var anno = parseInt(pezzi[1], 10);

      return new Date(anno, mese - 1, 1);
    }

    function getUltimoGiornoDelMeseDaChiave(chiaveMese) {
      var pezzi = chiaveMese.split('/');
      if(pezzi.length !== 2) return null;

      var mese = parseInt(pezzi[0], 10);
      var anno = parseInt(pezzi[1], 10);

      return new Date(anno, mese, 0);
    }

    function isMeseParziale(chiaveMese) {
      var dataInizio = dataPartenza.current && dataPartenza.current.value ? parseDataSoloGiorno(dataPartenza.current.value) : null;
      var dataFine = dataArrivo.current && dataArrivo.current.value ? parseDataSoloGiorno(dataArrivo.current.value) : null;

      if(!dataInizio || !dataFine) return false;

      var primoDelMese = getPrimoGiornoDelMeseDaChiave(chiaveMese);
      var ultimoDelMese = getUltimoGiornoDelMeseDaChiave(chiaveMese);

      if(!primoDelMese || !ultimoDelMese) return false;

      var chiaveMeseInizio = getChiaveMeseDaData(dataInizio);
      var chiaveMeseFine = getChiaveMeseDaData(dataFine);

      if(chiaveMese === chiaveMeseInizio && dataInizio.getDate() !== 1) {
        return true;
      }

      if(chiaveMese === chiaveMeseFine && dataFine.getDate() !== ultimoDelMese.getDate()) {
        return true;
      }

      return false;
    }

    function etichettaMeseSintesi(chiaveMese) {
      return isMeseParziale(chiaveMese) ? chiaveMese + " parziale" : chiaveMese;
    }

    function formattaMese(dataIso) {
      if(!dataIso) return "";
      var data = dataIso.split('T')[0].split('-');
      if(data.length !== 3) return "";
      return data[1] + "/" + data[0];
    }

    function getRigheSintesiTotale() {
      var mappa = {};

      for (var i = 0; i < risultatoPrenotazioni.length; i++) {
        if (Number(risultatiStato[i]) === -1) continue; // lista di attesa
        if (Number(risultatiStato[i]) === 2) continue; // prenotazine annullata

        var corso = risultatiDescrizione[i] || "";
        var chiave = corso;

        if (!mappa[chiave]) {
          mappa[chiave] = {
            corso: corso,
            numeroPrenotazioni: 0
          };
        }

        mappa[chiave].numeroPrenotazioni++;
      }

      var arr = Object.keys(mappa).map(function(chiave) {
        return mappa[chiave];
      });

      arr.sort(function(a,b){
        if(a.corso < b.corso) return -1;
        if(a.corso > b.corso) return 1;
        return 0;
      });

      return arr;
    }    

    function getRigheSintesi() {
      var mappa = {};

      for (var i = 0; i < risultatoPrenotazioni.length; i++) {
        if (Number(risultatiStato[i]) === -1) continue; // lista di attesa
        if (Number(risultatiStato[i]) === 2) continue; // prenotazine annullata

        var mese = formattaMese(risultatiDa[i]);
        var corso = risultatiDescrizione[i] || "";
        var chiave = mese + "|||" + corso;

        if (!mappa[chiave]) {
          mappa[chiave] = {
            mese: mese,
            meseVisualizzato: etichettaMeseSintesi(mese),
            corso: corso,
            numeroPrenotazioni: 0
          };
        }

        mappa[chiave].numeroPrenotazioni++;
      }

      var arr = Object.keys(mappa).map(function(chiave) {
        return mappa[chiave];
      });

      arr.sort(function(a,b){
        var pa = a.mese.split('/');
        var pb = b.mese.split('/');

        var meseA = parseInt(pa[0], 10);
        var annoA = parseInt(pa[1], 10);

        var meseB = parseInt(pb[0], 10);
        var annoB = parseInt(pb[1], 10);

        if(annoA < annoB) return -1;
        if(annoA > annoB) return 1;

        if(meseA < meseB) return -1;
        if(meseA > meseB) return 1;

        if(a.corso < b.corso) return -1;
        if(a.corso > b.corso) return 1;

        return 0;
      });

      return arr;
    }    

    function stileRiga(index) {
      if (Number(risultatiStato[index]) === -1) {
        // lista attesa
        return {
          backgroundColor: '#ecfc9e',
          color: '#2d2084'
        };
      }
      if (Number(risultatiStato[index]) === 2) {
        // prenotazione annullata
        return {
          backgroundColor: '#f8d7da',
          color: '#842029'
        };
      }
      return {};
    }

    const righeSintesi = getRigheSintesi();
    const righeSintesiTotale = getRigheSintesiTotale();

  return (
    <div id="cont" style={{minHeight: "100%",backgroundColor:"#F2F2F2"}}><Clessidra loading={loading}/>

      {statoPagina === STATO_SCARICA_PDF ?
      <div>
        <PDFViewer
          style={{
            height: props.dimensioniApp.yMain - 50,
            width: larghezzaPdf,
            display:"flex",
            flexDirection:"column",
            backgroundColor:"transparent"
          }}
        >

          <Document>
            <Page size="A4" style={styles.page}>
              <View style={{width:"100%"}} >
                <View style={styles.tableIntestazione}>
                  <View wrap={false} style={styles.tableRowIntestazione}>
                    <View style={styles.tableColIntestazioneSx}>
                      <View style={styles.tableCell}>
                        {fileLogo !== "" ? <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />:<Text></Text>}
                      </View>
                    </View>
                    <View style={styles.tableColIntestazioneDx}>
                      <View style={styles.tableCellIntestazione}>
                        {nomeSocieta !== "" ?<Text style={styles.nomesocieta}>{nomeSocieta}</Text>:<Text></Text>}
                        {indirizzoSocieta !== "" ?
                        <Text style={styles.datisocieta}>{indirizzoSocieta}
                        {cittaSocieta !== "" ?
                          capSocieta !== "" ?
                            " "+capSocieta+" "+cittaSocieta
                          :" "+cittaSocieta
                        :""}
                        </Text>
                        :<Text></Text>}
                        {pIvaSocieta !== "" ?<Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text>:<Text></Text>}
                        {codiceFiscaleSocieta !== "" ?<Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text>:<Text></Text>}

                        <Text style={styles.titolo}>
                          {modalitaReport === 'elenco' ? 'Elenco Prenotazioni' :
                            modalitaReport === 'sintesiMese' ? 'Sintesi Prenotazioni per Mese' :
                            'Sintesi Totale Prenotazioni'}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>

                <View>
                  <Text style={styles.titoloPiccolo}>Report generato il <TrasformaDateAUmano data={dataOggi}></TrasformaDateAUmano></Text>
                </View>

                <View wrap={false}>
                  {insIdPersonaEdi !=='' ?
                    <View>
                      <Text style={styles.titoloPiccolo}>Iscritto: {insPersonaEdi}</Text>
                    </View>
                  :""}
                  {insIdPrestazioneEdi !==''?
                    <View>
                      <Text style={styles.titoloPiccolo}>Prestazione / Attrezzatura: {insPrestazioneEdi}</Text>
                    </View>
                  :""}
                  {dataPartenza.current && dataPartenza.current.value!==''?
                    <View>
                      <Text style={styles.titoloPiccolo}>Inizio Periodo di Analisi: <TrasformaDateAUmano data={dataPartenza.current.value}></TrasformaDateAUmano></Text>
                    </View>
                  :""}
                  {dataArrivo.current && dataArrivo.current.value!=='' ?
                    <View>
                      <Text style={styles.titoloPiccolo}>Fine Periodo di Analisi: <TrasformaDateAUmano data={dataArrivo.current.value}></TrasformaDateAUmano></Text>
                    </View>
                  :""}
                </View>

                {modalitaReport === 'elenco' ?
                <View style={styles.table}>
                  <View wrap={false} style={styles.tableRowBlu}>
                    <View style={styles.tableCol8Di100}>
                      <Text style={styles.tableCellGrassettoAllineatoSinistra}></Text>
                    </View>

                    <View style={styles.tableCol32Di100}>
                      <Text style={styles.tableCellGrassettoAllineatoSinistra}>Iscritto</Text>
                    </View>

                    <View style={styles.tableCol20Di100}>
                      <Text style={styles.tableCellGrassettoAllineatoSinistra}>Prestazione / Attrezzatura</Text>
                    </View>

                    <View style={styles.tableCol30Di100}>
                      <Text style={styles.tableCellGrassettoAllineatoSinistra}>Data</Text>
                    </View>

                    <View style={styles.tableCol10Di100}>
                      <Text style={styles.tableCellGrassettoAllineatoSinistra}>Stato</Text>
                    </View>
                  </View>

                  {risultatiDescrizione.map((elemento,index) => {
                    const testoAnnullata = Number(risultatiStato[index]) === 2 ? {color:"#842029"} : {};
                    const sfondoRiga = Number(risultatiStato[index]) === 2 ? {backgroundColor:"#f8d7da"} : {};

                    return (
                      <View style={[styles.tableRow, sfondoRiga]} wrap={false} key={index}>
                        <View style={styles.tableCol8Di100}>
                          <Text style={[styles.tableCell, testoAnnullata]}>
                            {index+1}
                          </Text>
                        </View>

                        <View style={styles.tableCol32Di100}>
                          <Text style={[styles.tableCellAllineatoSinistra, testoAnnullata]}>
                            {risultatiCognome[index]} {risultatiNome[index]} ({risultatiTessera[index]})
                          </Text>
                        </View>

                        <View style={styles.tableCol20Di100}>
                          <Text style={[styles.tableCellAllineatoSinistra, testoAnnullata]}>
                            {risultatiDescrizione[index]}
                          </Text>
                        </View>

                        <View style={styles.tableCol30Di100}>
                          <Text style={[styles.tableCellAllineatoSinistra, testoAnnullata]}>
                            {formattaDataOraIntervallo(risultatiDa[index], risultatiA[index])}
                          </Text>
                        </View>

                        <View style={styles.tableCol10Di100}>
                          <Text style={[styles.tableCellAllineatoSinistra, testoAnnullata]}>
                            {decodificaStato(risultatiStato[index])}
                          </Text>
                        </View>
                      </View>
                    );
                  })}
                </View>
              :
                modalitaReport === 'sintesiMese' ?
                  <View style={styles.table}>
                    <View wrap={false} style={styles.tableRowBlu}>
                      <View style={styles.tableCol25Di100}>
                        <Text style={styles.tableCellGrassettoAllineatoSinistra}>Mese</Text>
                      </View>
                      <View style={styles.tableCol55Di100}>
                        <Text style={styles.tableCellGrassettoAllineatoSinistra}>Corso</Text>
                      </View>
                      <View style={styles.tableCol20Di100}>
                        <Text style={styles.tableCellGrassettoAllineatoSinistra}>Numero Prenotazioni</Text>
                      </View>
                    </View>

                    {righeSintesi.map((riga,index) => (
                      <View style={styles.tableRow} wrap={false} key={index}>
                        <View style={styles.tableCol25Di100}>
                          <Text style={styles.tableCellAllineatoSinistra}>{riga.meseVisualizzato}</Text>
                        </View>
                        <View style={styles.tableCol55Di100}>
                          <Text style={styles.tableCellAllineatoSinistra}>{riga.corso}</Text>
                        </View>
                        <View style={styles.tableCol20Di100}>
                          <Text style={styles.tableCellAllineatoSinistra}>{riga.numeroPrenotazioni}</Text>
                        </View>
                      </View>
                    ))}
                  </View>
                :
                  <View style={styles.table}>
                    <View wrap={false} style={styles.tableRowBlu}>
                      <View style={styles.tableCol80Di100}>
                        <Text style={styles.tableCellGrassettoAllineatoSinistra}>Corso</Text>
                      </View>
                      <View style={styles.tableCol20Di100}>
                        <Text style={styles.tableCellGrassettoAllineatoSinistra}>Numero Prenotazioni</Text>
                      </View>
                    </View>

                    {righeSintesiTotale.map((riga,index) => (
                      <View style={styles.tableRow} wrap={false} key={index}>
                        <View style={styles.tableCol80Di100}>
                          <Text style={styles.tableCellAllineatoSinistra}>{riga.corso}</Text>
                        </View>
                        <View style={styles.tableCol20Di100}>
                          <Text style={styles.tableCellAllineatoSinistra}>{riga.numeroPrenotazioni}</Text>
                        </View>
                      </View>
                    ))}
                  </View>
                }
              </View>

              <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
            </Page>
          </Document>
        </PDFViewer>

        <div style={{
          display:"flex",
          justifyContent:"center",
          padding:10,
          backgroundColor:"#F2F2F2"
        }}>
          <Button
            color="primary"
            onClick={() => {
              setVisualizzaInPdf(false);
              setStatoPagina(STATO_OPERAZIONE_CORRETTA);
            }}
          >
            Torna indietro
          </Button>
        </div>

      </div>
      :""}

      {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1E_R_ElePren</div> :""}
      {statoPagina === STATO_RICERCA_DATI || statoPagina === STATO_RICERCA_DATI_DETTAGLIO ? <Card className="main-card mb-3"><Clessidra loading={true}/></Card> :""}

      {statoPagina === STATO_OPERAZIONE_CORRETTA ?

        <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
          <Row>
            <Col lg="12">
              <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                {visualizzaInPdf === true ?
                  <div id='idDivGenerazionePdf' style={{display:'none'}}>Generazione PDF in corso...</div>
                :""}

                <CardTitle id="titolo">Elenco Prenotazioni</CardTitle>

                <Row form>
                  <Col md={3}>
                    <Label for="iscritto">Iscritto</Label>
                    <TendinaEditabile
                      nomeCampo="COGNOME"
                      nomeCampo2="NOME"
                      nomeCampoParentesi="NUMERO_TESSERA"
                      nomeCampoNonVisibile="ID"
                      bloccoInserimento = "1"
                      valoreDefault={defaultPersona}
                      arrayValori={risultatoServerDatiPersona}
                      inserisciCampoTutti = "1"
                      callbackSetVariazioneCampi={callbackSetVariazioneCampi}
                      callbackSetValoreTendEditabile={callbackSetValoreTendEditabilePersona}
                    ></TendinaEditabile>
                  </Col>

                  <Col md={3}>
                    <Label for="corso">Prestazione / Attrezzatura</Label>
                    <TendinaEditabile
                      nomeCampo="NOME"
                      nomeCampoNonVisibile="ID"
                      bloccoInserimento = "1"
                      valoreDefault={defaultPrestazione}
                      arrayValori={risultatoServerDatiPrestazioni}
                      inserisciCampoTutti = "1"
                      callbackSetVariazioneCampi={callbackSetVariazioneCampi}
                      callbackSetValoreTendEditabile={callbackSetValoreTendEditabilePrestazione}
                    ></TendinaEditabile>
                  </Col>

                  <Col md={2}>
                    <Label>Inizio Periodo di Analisi</Label>
                    <Input
                      type="date"
                      name="dataPartenza"
                      id="dataPartenza"
                      value={dataPartenzaDefault}
                      innerRef={dataPartenza}
                      placeholder=""
                      onChange={(e)=>{setDataPartenzaDefault(e.target.value)}}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Fine Periodo di Analisi</Label>
                    <Input
                      type="date"
                      name="dataArrivo"
                      id="dataArrivo"
                      value={dataArrivoDefault}
                      innerRef={dataArrivo}
                      placeholder=""
                      onChange={(e)=>{setDataArrivoDefault(e.target.value)}}
                    />
                  </Col>

                  <Col md={2}>
                    <div style={{paddingTop:24, display:"flex", gap:8, flexWrap:"wrap"}}>
                      <Button
                        color="success"
                        className="mt-2"
                        onClick={() => {
                          setModalitaReport('elenco');
                          setVisualizzaInPdf(false);
                          setCalcola(true);
                        }}
                      >
                        Elenco
                      </Button>

                      <Button
                        color="primary"
                        className="mt-2"
                        onClick={() => {
                          setModalitaReport('sintesiMese');
                          setVisualizzaInPdf(false);
                          setCalcola(true);
                        }}
                      >
                        Sintesi per Mese
                      </Button>

                      <Button
                        color="info"
                        className="mt-2"
                        onClick={() => {
                          setModalitaReport('sintesiTotale');
                          setVisualizzaInPdf(false);
                          setCalcola(true);
                        }}
                      >
                        Sintesi Totale
                      </Button>
                    </div>
                  </Col>
                </Row>

                {visualizza === true ?
                  <Row form style={{marginTop:10, marginBottom:10}}>
                    <Col>
                      <Button color="primary" onClick={(e)=>{setVisualizzaInPdf(true)}}>Esporta il PDF</Button>
                    </Col>
                  </Row>
                :""}

                <div id="dettaglioReport">
                  {visualizza === true ?
                    risultatoPrenotazioni.length === 0 ?
                      <Fragment>
                        <Row form className="border">
                          <Col md='12'><b>Non risultano prenotazioni che soddisfino le condizioni impostate</b></Col>
                        </Row>
                      </Fragment>
                    :
                      <Fragment>

                        <Row form style={{marginTop:10, marginBottom:10}}>
                          <Col>
                            <b>
                              {modalitaReport === 'elenco' ? 'Report' :
                                modalitaReport === 'sintesiMese' ? 'Sintesi per Mese' :
                                'Sintesi Totale'} del <TrasformaDateAUmano data={dataOggi}></TrasformaDateAUmano>
                            </b>
                          </Col>
                        </Row>

                        {modalitaReport === 'elenco' ?
                          <Fragment>
                            <Row form className="rigaTitoloTabellaReport">
                              <Col md={1} className="titoloTabellaReport"><b></b></Col>
                              <Col md={4} className="titoloTabellaReport">Iscritto</Col>
                              <Col md={2} className="titoloTabellaReport">Prestazione / Attrezzatura</Col>
                              <Col md={4} className="titoloTabellaReport">Data</Col>
                              <Col md={1} className="titoloTabellaReport">Stato</Col>
                            </Row>

                            {risultatiDescrizione.map((elemento,index) => <Row className="rigaTabellaReport" key={index} style={stileRiga(index)}>
                              <Col md={1}><center>{index+1}</center></Col>
                              <Col md={4}>{risultatiCognome[index]} {risultatiNome[index]} {risultatiTessera[index]}</Col>
                              <Col md={2}>{risultatiDescrizione[index]}</Col>
                              <Col md={4}>{formattaDataOraIntervallo(risultatiDa[index], risultatiA[index])}</Col>
                              <Col md={1}>{decodificaStato(risultatiStato[index])}</Col>
                            </Row>)}
                          </Fragment>
                        :
                        modalitaReport === 'sintesiMese' ?
                          <Fragment>
                            <Row form className="rigaTitoloTabellaReport">
                              <Col md={3} className="titoloTabellaReport">Mese</Col>
                              <Col md={6} className="titoloTabellaReport">Corso</Col>
                              <Col md={3} className="titoloTabellaReport">Numero Prenotazioni</Col>
                            </Row>

                            {righeSintesi.map((riga,index) => <Row className="rigaTabellaReport" key={index}>
                              <Col md={3}>{riga.meseVisualizzato}</Col>
                              <Col md={6}>{riga.corso}</Col>
                              <Col md={3}>{riga.numeroPrenotazioni}</Col>
                            </Row>)}
                          </Fragment>
                        :
                          <Fragment>
                            <Row form className="rigaTitoloTabellaReport">
                              <Col md={9} className="titoloTabellaReport">Corso</Col>
                              <Col md={3} className="titoloTabellaReport">Numero Prenotazioni</Col>
                            </Row>

                            {righeSintesiTotale.map((riga,index) => <Row className="rigaTabellaReport" key={index}>
                              <Col md={9}>{riga.corso}</Col>
                              <Col md={3}>{riga.numeroPrenotazioni}</Col>
                            </Row>)}
                          </Fragment>
                        }
                      </Fragment>
                  :""}
                </div>

              </div>
            </Col>
          </Row>
        </div>
      :""}
    </div>
   );
}
export default TabellaElencoPrenotazioni;